import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackbarData, SnackbarType } from '@shared/models/snackbar.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: 'snackbar.component.html',
  standalone: false,
})
export class SnackbarComponent {
  public SnackType = SnackbarType;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData) {}
}
